export enum EApplicationStore {
	APP_STORE = 'app_store',
	GOOGLE_PLAY = 'google_play',
	HUAWEI_APP_GALLERY = 'huawei_app_gallery',
}